import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UnbindModel from '@/views/home/models/unbind-model.vue';
import Subject from '@/components/subject.vue';
import BoxMain from '@/views/study/components/box-main.vue';
import Filing from '@/components/filing.vue';
import { getBoxList as _getBoxList } from '@/api/modules/study.js';
import OutlineCache from '@/utils/OutlineCache.js';
import { mapGetters } from 'vuex';
import { captureException } from '@/utils/sentry';
var cache = OutlineCache.getInstance();
export default {
  name: 'Study',
  components: {
    UnbindModel: UnbindModel,
    Subject: Subject,
    BoxMain: BoxMain,
    Filing: Filing
  },
  data: function data() {
    return {
      visible: false,
      boxId: '',
      boxes: [],
      edu: JSON.parse(localStorage.getItem('userInfo')).edu,
      subjectCode: 0,
      subjectMsg: {}
    };
  },
  computed: _objectSpread({}, mapGetters(['subjectGetters', 'studyBindSuccess'])),
  watch: {
    subjectGetters: function subjectGetters(val) {
      this.subjectCode = +val;
      this.switchSubject(val);
    },
    studyBindSuccess: function studyBindSuccess() {
      this.activeSuccess();
    }
  },
  created: function created() {
    // 缓存单例，用于处理缓存信息
    this.subjectCode = +this.subjectGetters || cache.getCurrentSubject(this.edu);
  },
  methods: {
    getBoxList: function getBoxList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var errInfo, _yield$_getBoxList, status, data, _this$boxes$;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!Number.isNaN(_this.subjectCode)) {
                  _context.next = 4;
                  break;
                }

                errInfo = new Error(JSON.stringify({
                  type: 'subjectId为NaN',
                  subjectCode: _this.subjectCode,
                  subjectGetters: _this.subjectGetters,
                  subjectGetters2: +_this.subjectGetters,
                  eduSubject: cache.getCurrentSubject(_this.edu)
                }));
                captureException(errInfo);
                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return _getBoxList({
                  subjectId: _this.subjectCode,
                  // 学科id
                  edu: _this.edu // 学段 3 初中 4 高中

                });

              case 6:
                _yield$_getBoxList = _context.sent;
                status = _yield$_getBoxList.status;
                data = _yield$_getBoxList.data;

                if (!(status !== 1 || !data)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                _this.boxes = (data === null || data === void 0 ? void 0 : data.boxList) || [];
                _this.boxId = cache.getCurrentBox(_this.edu, _this.subjectCode);

                if (_this.boxes.every(function (box) {
                  return box.boxId !== +_this.boxId;
                })) {
                  // 当前自学宝列表中，不包含缓存的自学宝，说明删掉了，必须重新赋值
                  cache.removeBox(_this.edu, _this.subjectCode, _this.boxId);
                  _this.boxId = ((_this$boxes$ = _this.boxes[0]) === null || _this$boxes$ === void 0 ? void 0 : _this$boxes$.boxId) + '';
                  cache.switchBox(_this.edu, _this.subjectCode, _this.boxId);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    switchSubject: function switchSubject(subjectCode, subject) {
      // 切换科目
      // this.subjectMsg = subject || this.subjectMsg
      if (this.subjectCode !== subjectCode) {
        this.subjectCode = subjectCode;
        cache.switchSubject(this.edu, subjectCode, true);
        this.$store.dispatch('setSubject', subjectCode);
      }

      this.getBoxList();
    },
    changeBox: function changeBox(boxId, box) {
      // 切换自学宝
      this.boxId = boxId;
      cache.switchBox(this.edu, this.subjectCode, boxId);
    },
    inactivated: function inactivated() {
      // 弹出激活
      this.visible = !this.visible;
    },
    activeSuccess: function activeSuccess() {
      window.location.reload();
    }
  }
};